export const EMPTY_FILTER_PARAMS = {
  title: '',
  categoryId: 0,
  subcategoryId: 0,
  menuTypeId: 0,
};
